import { useCallback } from 'react';

import { useLocalStorage } from 'usehooks-ts';

import { useAuth } from '@shared/common/providers/AuthProvider';

import useCheckRequiredSelfData from '@store:web/utils/hooks/useCheckRequiredSelfData';

/**
 * NOTE: mostly using it for communication between tabs as a requirement for storm trade story
 * (story has verify buttons, each button opens settings page in new tab and we need to know
 * if user made described verification action to show appropriate ui on story page)
 * TODO: we make possibly to edit profile info from story to get rid of this hook
 */
const useSelfDataCheckLocalStorage = () => {
  const { user } = useAuth();
  const {
    hasEmail,
    hasEvmWallet,
    hasTonWallet,
    hasUsername,
    hasFaceVerification,
    hasGitcoinVerification,
    hasLinkedTelegram,
  } = useCheckRequiredSelfData();
  const [value, setValue] = useLocalStorage(`${user?.id}:checks`, {
    hasEmail,
    hasEvmWallet,
    hasTonWallet,
    hasUsername,
    hasFaceVerification,
    hasGitcoinVerification,
    hasLinkedTelegram,
  });

  const resetValue = useCallback(() => {
    setValue({
      hasEmail,
      hasEvmWallet,
      hasTonWallet,
      hasUsername,
      hasFaceVerification,
      hasGitcoinVerification,
      hasLinkedTelegram,
    });
  }, [
    hasEmail,
    hasEvmWallet,
    hasTonWallet,
    hasUsername,
    hasFaceVerification,
    hasGitcoinVerification,
    hasLinkedTelegram,
    setValue,
  ]);

  return {
    value,
    setValue,
    resetValue,
  };
};

export default useSelfDataCheckLocalStorage;
